import React from 'react';
import TagMoveButtons from '../TagMoveButtons';
import { TagsToolbarPopupProps } from '../popup/TagsToolbarPopup';
import TagDeleteButton from '../TagDeleteButton';

const MobileTagEditContent: React.FC<TagsToolbarPopupProps> = (props) => {
    return (
        <div className="MobileTagEditContent">
            <TagMoveButtons {...props} />
            <TagDeleteButton {...props} />
        </div>
    );
};

export default MobileTagEditContent;
